<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link :to="{ name: 'Pre Plan' }" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>
              <td>{{ broadcasterById.broadcasterName }}</td>
            </h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData(id)"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deleteBroadcasterPopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.BroadcasterCode") }}</b>
                    </td>
                    <td>{{ broadcasterById.broadcasterCode }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.BroadcasterName") }}</b>
                    </td>
                    <td>{{ broadcasterById.broadcasterName }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.MobileNo") }}</b>
                    </td>
                    <td>{{ broadcasterById.contactMobile }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.LandlineNo") }}</b>
                    </td>
                    <td>{{ broadcasterById.contactNumber }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.ContactPerson") }}</b>
                    </td>
                    <td>{{ broadcasterById.contactName }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Email") }}</b>
                    </td>
                    <td>{{ broadcasterById.email }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Address") }}</b>
                    </td>
                    <td>{{ broadcasterById.address }}</td>
                  </tr>
                  <tr>
                    <td class="border-none">
                      <b>{{ $t("setup.label.GstRegNumber") }} </b>
                    </td>
                    <td class="border-none">{{ broadcasterById.pin }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Id") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.ChannelName") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.ChannelType") }}</b>
                    </td>
                  </tr>

                  <tr
                    v-for="(Broadcaster, index) in broadcasterById.channelDatas"
                    :key="index"
                  >
                    <td>{{ Broadcaster.id }}</td>
                    <td>{{ Broadcaster.channelName }}</td>
                    <td>{{ Broadcaster.channelType }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteBroadcasterPopup"
      :title="$t('setup.label.Broadcaster')"
      @deletePressed="deleteBroadcaster()"
      @cancelPressed="deleteBroadcasterPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";
import { mapState } from "vuex";
export default {
  data() {
    return {
      editJobsPopup: false,
      delId: 0,
      redirectToEdit: false,
      deleteBroadcasterPopup: false,
      updateCraditPopup: false,
      jobsParameterPopup: false,
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      broadcasterById: (state) => state.broadcaster.broadcasterById,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    editData(id) {
      this.$router.push({
        name: "Edit Broadcaster",
        params: { id: this.$route.params.id },
      });
    },
    async deleteBroadcaster() {
      this.deleteBroadcasterPopup = false;
      try {
        await this.$store.dispatch(
          "broadcaster/deleteBroadcasterAction",
          this.$route.params.id
        );
        this.$router.push(`/broadcaster`);
      } catch (error) {
        this.$toasted.error(e.message);
      }
    },

    async getBroadcasterById() {
      try {
        await this.$store.dispatch(
          "broadcaster/setBroadcasterById",
          this.$route.params.id
        );
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
  },
  mounted() {
    this.getBroadcasterById();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
